import React from "react";

import { Network } from "../../services/NetworkApi";
import { ReadOnlyWrapper } from "../ReadOnlyWrapper";
import { WrapperWithTitle } from "../WrapperWithTitle";
import { Grid } from "../../UI/Grid";
import { Radio } from "../../UI/Radio";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";

interface IProps {
  l2?: Network | null;
  onChange: (key: string, value: boolean) => void;
  isDisabled?: boolean;
}

export const GenderEnabled: React.FC<IProps> = (props) => {
  const { isSuperAdminRead } = useAuth();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = React.useState(false);
  const [enabled, setEnabled] = React.useState(
    String(!!props.l2?.genderNetworkSettingsTransport.genderSelectionEnabled)
  );

  const handleChange = async ({ currentTarget: { value } }: React.SyntheticEvent<any>) => {
    setIsLoading(true);

    try {
      await props.onChange("genderSelectionEnabled", JSON.parse(value));
      setEnabled(value);

      showSuccessSnackbar("Saved Changes");
    } catch (error) {
      showErrorSnackbar("An Error Occurred");
    }

    setIsLoading(false);
  };

  React.useEffect(() => {
    setEnabled(String(!!props.l2?.genderNetworkSettingsTransport.genderSelectionEnabled));
  }, [props.l2?.genderNetworkSettingsTransport.genderSelectionEnabled]);

  return (
    <WrapperWithTitle title="Would you like to ask residents for their gender?">
      <ReadOnlyWrapper>
        <Grid container spacing={2}>
          <Grid item>
            <Radio
              isDisabled={isLoading || props.isDisabled || isSuperAdminRead()}
              isChecked={enabled === String(true)}
              value={String(true)}
              label="Yes"
              onChange={handleChange}
            />
          </Grid>
          <Grid item>
            <Radio
              isDisabled={isLoading || props.isDisabled || isSuperAdminRead()}
              isChecked={enabled === String(false)}
              value={String(false)}
              label="No"
              onChange={handleChange}
            />
          </Grid>
        </Grid>
      </ReadOnlyWrapper>
    </WrapperWithTitle>
  );
};
